import React from 'react';
import { IVendorVariantInternal } from '../../models/VendorVariant/i-vendor-variant';

/* istanbul ignore next */
const VendorVariantContext = React.createContext<IVendorVariantInternal>(
  {} as IVendorVariantInternal
);

export default VendorVariantContext;
